import { createTheme } from '@mui/material/styles';

export const nightTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#06b6d4',
    },
    secondary: {
      main: '#2563eb',
    },
    background: {
      default: '#0f172a',
      paper: '#1e293b',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        ':root': {
          /* Surfaces */
          '--surface-bg': '#1e293b',
          '--surface-color': '#e2e8f0',
          '--surface-border': '#334155',
          /* Page */
          '--page-bg': '#0f172a',
          /* Text */
          '--heading-color': '#e2e8f0',
          '--subtext-color': '#94a3b8',
          '--body-text': '#cbd5e1',
          /* Borders */
          '--border-color': '#334155',
          /* Table rows */
          '--row-even-bg': 'rgba(6,182,212,0.07)',
          '--row-odd-bg': 'rgba(255,255,255,0.02)',
          '--row-even-hover-bg': 'rgba(6,182,212,0.15)',
          '--row-odd-hover-bg': 'rgba(255,255,255,0.06)',
          /* Inputs */
          '--input-bg': '#1e293b',
          /* Info boxes & containers */
          '--info-box-bg': '#283548',
          '--muted-bg': '#283548',
        },
      },
    },
  },
});

export const dayTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#0097a7',
    },
    secondary: {
      main: '#1d4ed8',
    },
    background: {
      default: '#f0f4f8',
      paper: '#ffffff',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        ':root': {
          /* Surfaces */
          '--surface-bg': '#ffffff',
          '--surface-color': '#1a1a1a',
          '--surface-border': '#e2e8f0',
          /* Page */
          '--page-bg': '#f0f4f8',
          /* Text */
          '--heading-color': '#090a38',
          '--subtext-color': '#666666',
          '--body-text': '#1a1a1a',
          /* Borders */
          '--border-color': '#d1d5db',
          /* Table rows */
          '--row-even-bg': '#d6ecf682',
          '--row-odd-bg': '#f8f8f8c4',
          '--row-even-hover-bg': '#d6ecf6ce',
          '--row-odd-hover-bg': '#e4e6eb64',
          /* Inputs */
          '--input-bg': '#ffffff',
          /* Info boxes & containers */
          '--info-box-bg': '#D9D9D9',
          '--muted-bg': '#e8edf2',
        },
      },
    },
  },
});

